import {
  FieldType,
  OAlert,
  OButton,
  OField
} from '@dnvgl-onefoundation/onedesign-react'
import React from 'react'

interface Props {
  title: string
  iconClass?: string
  isLandfill?: boolean
  isDisabled?: boolean
  providerName?: string
  selectButtonVariant?: 'secondary' | 'subtle'
  onSelectClick?: () => void
  onResetClick?: () => void
  onToggleRequired?: () => void
}

const SelectProviderControl = ({
  title,
  iconClass,
  isLandfill,
  isDisabled,
  providerName,
  selectButtonVariant,
  onSelectClick,
  onResetClick,
  onToggleRequired
}: Props) => (
  <div className="pt-3 p-2 border-bottom">
    <div className="mb-2">
      <span>
        <i className={`${iconClass} fg-dark-blue mr-2`} />
        {title}
      </span>
    </div>
    {providerName ? (
      <OAlert
        dismissable={!isDisabled}
        variant="info"
        message={providerName}
        showIcon={false}
        onDismiss={() => onResetClick?.()}
      />
    ) : !isLandfill ? (
      <OButton
        variant={selectButtonVariant}
        className="w-100"
        onClick={() => {
          onSelectClick?.()
        }}>
        Click to select
      </OButton>
    ) : (
      <div className="p-2 border bg-light">N.A.</div>
    )}
    {!providerName && (
      <div className="mt-2">
        <OField
          value={{ isLandFill: !!isLandfill }}
          onChange={() => onToggleRequired?.()}
          field={{
            heading: 'Landfill',
            name: 'isLandFill',
            type: FieldType.Checkbox
          }}
        />
      </div>
    )}
  </div>
)

export default React.memo(SelectProviderControl)
